module.exports = __webpack_public_path__ + "static/media/bright_future.27badb71.png";